import classNames from 'classnames'
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from 'react-icons/md'

import type { ReactElement } from 'react'

import Button from '~/components/Buttons/Button'

import './styles.scss'

export interface Props {
  className?: string
  currentPage: number
  goBack?: VoidFunction
  goNext?: VoidFunction
  goToPage: (page: number) => void
  pageTotal: number
}

const MIN_DISPLAYED_ITEMS = 3

const ICON_COLOR = '#62625D'

const ICON_SIZE = 15

const Pagination = ({ className, currentPage, goBack, goNext, goToPage, pageTotal }: Props): ReactElement | null => {
  const buttonsIdx = Array.from(Array(pageTotal).keys())

  const handleGoToPage = (idx: number) => () => goToPage(idx)

  return (
    <div className={classNames('pagination-component', className)}>
      {currentPage > 0 && (
        <Button className="command-button" ghost onClick={goBack}>
          <MdKeyboardArrowLeft color={ICON_COLOR} data-name="chevron-left" size={ICON_SIZE} />
        </Button>
      )}
      <div className="paginated-buttons-container">
        {currentPage > 1 && pageTotal > MIN_DISPLAYED_ITEMS ? (
          <>
            <Button className="button" ghost onClick={handleGoToPage(0)} role="button">
              1
            </Button>
            <div className="button spread">...</div>
          </>
        ) : null}
        {[...buttonsIdx].slice(currentPage > 0 ? currentPage - 1 : 0, currentPage + 2).map((idx) => (
          <Button
            className={classNames('button', { active: currentPage === idx })}
            ghost
            key={`key-${idx}`}
            onClick={handleGoToPage(idx)}
            role="button"
          >
            {idx + 1}
          </Button>
        ))}
        {pageTotal > MIN_DISPLAYED_ITEMS && currentPage + MIN_DISPLAYED_ITEMS < pageTotal ? (
          <div className="button spread">...</div>
        ) : null}
        {currentPage + 2 < pageTotal ? (
          <Button className="button" ghost onClick={handleGoToPage(pageTotal - 1)} role="button">
            {pageTotal}
          </Button>
        ) : null}
      </div>
      {pageTotal > 1 && currentPage + 1 !== pageTotal ? (
        <Button className="command-button" ghost onClick={goNext} role="button">
          <MdKeyboardArrowRight color={ICON_COLOR} data-name="chevron-right" size={ICON_SIZE} />
        </Button>
      ) : null}
    </div>
  )
}

export default Pagination
